import { useEffect, useState } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import { useTheme } from '../../hooks/useTheme';
import { COLORS, FONTS } from '../../styles/tokens';
import { AuditLogTable } from '../../components/admin/AuditLogTable';
import { fetchAuditLog, type AuditLogRow } from '../../lib/notifications-api';

/**
 * App deploy audit log — distinct from the Keycloak login-event AuditLog
 * page. Shows recent deploy/rollback/delete events across every app for
 * admins.
 */
export default function AppAuditLog(): React.JSX.Element {
  const { token } = useAuth();
  const { isDark } = useTheme();
  const colors = isDark ? COLORS.dark : COLORS.light;
  const [items, setItems] = useState<AuditLogRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchAuditLog(token)
      .then(rows => { if (!cancelled) setItems(rows); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <h1 className="vx-track" style={{ fontFamily: FONTS.heading, fontSize: '18px', letterSpacing: '0.15em', textTransform: 'uppercase', color: colors.text, margin: '0 0 16px' }}>
        App Deploy Audit Log
      </h1>
      {loading
        ? <p style={{ color: colors.textSecondary, fontFamily: FONTS.body, fontSize: '12px' }}>Loading…</p>
        : <AuditLogTable items={items} colors={colors} />
      }
    </div>
  );
}
